import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

const baseURI = '/catalogos/clasificacion-de-licencias';

/**
 * GET Clasificacion de Licencia
 * @returns {Promise<Array<object>>}
 */
export const getClasificacionDeLicencias = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Clasificacion de Licencia
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClasificacionDeLicencias = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clasificacion de Licencia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClasificacionDeLicencias = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Clasificacion de Licencia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClasificacionDeLicencias = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
